const translation = {
    en: {
        cancel: 'Cancel',
        close: 'Close',
        error: 'Error',
        info: 'Info',
        loading: 'Loading...',
        no: 'No',
        save: 'Save',
        update: 'Update',
        yes: 'Yes',
        time_tracking_admin_new_clocking: 'Save new clocking',
        time_tracking_admin_edit_clocking: 'Edit clocking',
        time_tracking_admin_clocking_saved: 'Clocking saved!',
        time_tracking_admin_error_occurred: 'An error occurred!',
        time_tracking_admin_fetch_shifts_error: 'Could not fetch clockings, please try again',
        time_tracking_admin_fetching_data: 'Fetching data...',
        time_tracking_calendar_save_shift: 'Save shift',
        time_tracking_calendar_saving: 'Saving...',
        time_tracking_calendar_fetch_employees_error: 'Could not fetch employees for the selected store.',
        time_tracking_calendar_unknown_user: 'Unknown user',
        time_tracking_calendar_select_shift_for_details: 'Select a shift in the calendar to view details.',
        time_tracking_calendar_details_coming_later: 'Detailed view will be available later.',
        time_tracking_calendar_shift_details: 'Shift details',
        time_tracking_calendar_employee: 'Employee',
        time_tracking_calendar_select_employee: 'Select employee',
        time_tracking_calendar_store: 'Store',
        time_tracking_calendar_from_time: 'From (time)',
        time_tracking_calendar_to_time: 'To (time)',
        time_tracking_calendar_shift_template: 'Shift template',
        time_tracking_calendar_no_template: 'No template',
        time_tracking_calendar_comment: 'Comment',
        time_tracking_calendar_optional_comment: 'Optional comment',
        time_tracking_calendar_required_fields: 'Fill in all required fields.',
        time_tracking_calendar_times_must_differ: 'Start time and end time cannot be the same.',
        time_tracking_calendar_edit_shift_not_found: 'Could not find the existing shift to edit.',
        time_tracking_calendar_updating_shift: 'Updating shift...',
        time_tracking_calendar_update_shift_error: 'Could not update the shift.',
        time_tracking_calendar_overlapping: 'overlapping',
        time_tracking_calendar_adjacent: 'adjacent',
        time_tracking_calendar_conflict_title: 'Adjacent or overlapping shifts',
        time_tracking_calendar_conflict_description: 'The employee already has a shift that is adjacent to or overlaps this period:',
        time_tracking_calendar_save_anyway: 'Save anyway',
        time_tracking_calendar_unknown_save_error: 'Unknown error while saving shift.',
        time_tracking_calendar_save_error: 'Could not save shift.',
        time_tracking_calendar_delete_target_not_found: 'Could not find the shift to delete.',
        time_tracking_calendar_unknown_delete_error: 'Unknown error while deleting shift.',
        time_tracking_calendar_delete_error: 'Could not delete shift.',
        time_tracking_calendar_delete_shift: 'Delete shift',
        time_tracking_calendar_selected_days: 'Selected days:',
        time_tracking_calendar_no_shifts: 'No shifts',
        time_tracking_calendar_hours_short: 'h',
        time_tracking_calendar_drop_to_move: 'Drop to move shift',
        time_tracking_calendar_drop_to_create: 'Drop to create shift',
        time_tracking_calendar_shift: 'Shift',
        time_tracking_calendar_week: 'Week',
        time_tracking_calendar_day_sun_short: 'Sun',
        time_tracking_calendar_day_mon_short: 'Mon',
        time_tracking_calendar_day_tue_short: 'Tue',
        time_tracking_calendar_day_wed_short: 'Wed',
        time_tracking_calendar_day_thu_short: 'Thu',
        time_tracking_calendar_day_fri_short: 'Fri',
        time_tracking_calendar_day_sat_short: 'Sat',
        time_tracking_calendar_month_january: 'January',
        time_tracking_calendar_month_february: 'February',
        time_tracking_calendar_month_march: 'March',
        time_tracking_calendar_month_april: 'April',
        time_tracking_calendar_month_may: 'May',
        time_tracking_calendar_month_june: 'June',
        time_tracking_calendar_month_july: 'July',
        time_tracking_calendar_month_august: 'August',
        time_tracking_calendar_month_september: 'September',
        time_tracking_calendar_month_october: 'October',
        time_tracking_calendar_month_november: 'November',
        time_tracking_calendar_month_december: 'December',
        time_tracking_calendar_no_days_selected: 'No days are selected.',
        time_tracking_calendar_save_multiple_error: 'Could not save one or more shifts.',
        time_tracking_calendar_template_fallback: 'Template',
        time_tracking_calendar_move_target_not_found: 'Could not find the shift to move.',
        time_tracking_calendar_invalid_move_cell: 'Invalid calendar cell for moving the shift.',
        time_tracking_calendar_partial_move_error: 'The shift was created in the new cell, but could not be deleted from the old cell.',
        time_tracking_calendar_move_error: 'Could not move the shift.',
        time_tracking_calendar_select_day_and_employee: 'Select a day and employee to create a shift.',
        time_tracking_calendar_shift_not_found: 'Could not find the shift.',
        time_tracking_calendar_delete_confirmation: 'Are you sure you want to delete this shift? This cannot be undone.',
        time_tracking_dashboard_user: 'User',
        time_tracking_dashboard_no_data: 'No data in the selected period.',
        time_tracking_dashboard_ongoing: 'Ongoing',
        time_tracking_dashboard_deviation: 'Deviation',
        time_tracking_dashboard_planned_hours: 'Planned hours',
        time_tracking_dashboard_actual_hours: 'Actual hours',
        time_tracking_dashboard_no_ongoing_shifts: 'No ongoing shifts.',
        time_tracking_dashboard_start: 'Start:',
        time_tracking_dashboard_changed_by: 'Changed by:',
        time_tracking_dashboard_click_for_actions: 'Click for actions',
        time_tracking_dashboard_in_progress: 'In progress',
        time_tracking_dashboard_without_planned_shift: 'Without a planned shift',
        time_tracking_dashboard_minor_deviation: 'Minor deviation',
        time_tracking_dashboard_minutes_late_in: 'min late clock-in',
        time_tracking_dashboard_minutes_early_in: 'min early clock-in',
        time_tracking_dashboard_minutes_overtime: 'min overtime',
        time_tracking_dashboard_minutes_early_out: 'min early clock-out',
        time_tracking_dashboard_no_history: 'No history in the selected period.',
        time_tracking_dashboard_comparison_description: 'Comparison of planned and actual working time',
        time_tracking_dashboard_planned: 'Planned',
        time_tracking_dashboard_actual: 'Actual',
        time_tracking_dashboard_comment: 'Comment:',
        time_tracking_dashboard_clocking_not_found: 'Could not find the clocking.',
        time_tracking_dashboard_ongoing_shift: 'Ongoing shift',
        time_tracking_dashboard_edit_shift: 'Edit shift',
        time_tracking_dashboard_in: 'In',
        time_tracking_dashboard_out: 'Out',
        time_tracking_dashboard_clock_out: 'Clock out',
        time_tracking_dashboard_save_changes: 'Save changes',
        time_tracking_dashboard_processing: 'Processing...',
        time_tracking_dashboard_invalid_time_range: 'Invalid time range.',
        time_tracking_dashboard_clocking_out: 'Clocking out...',
        time_tracking_dashboard_clock_out_in_progress: 'Processing clock-out...',
        time_tracking_dashboard_clock_out_error: 'Could not clock out.',
        time_tracking_dashboard_saving: 'Saving...',
        time_tracking_dashboard_saving_changes: 'Saving changes...',
        time_tracking_dashboard_update_clocking_error: 'Could not update clocking.',
        time_tracking_dashboard_export_payroll: 'Export payroll list',
        time_tracking_dashboard_export_period_description: 'Select a period for the Excel export.',
        time_tracking_dashboard_period: 'Period',
        time_tracking_dashboard_download_excel: 'Download Excel',
        time_tracking_dashboard_invalid_date_range: 'Select a valid date range.',
        time_tracking_dashboard_generating_excel: 'Generating Excel...',
        time_tracking_dashboard_generate_excel_error: 'Could not generate Excel',
        time_tracking_dashboard_excel_ready: 'Excel is ready.',
        time_tracking_dashboard_no_shifts_in_view: 'There are no shifts in the current calendar view.',
        time_tracking_dashboard_generate_pdf_error: 'Could not generate PDF',
        time_tracking_personnel_empty_keeps_number: 'Leave blank to keep the existing number.',
        time_tracking_personnel_national_id_locked: 'National identity number / D number is locked after it is saved for the first time.',
        time_tracking_personnel_update_information: 'Update personnel information',
        time_tracking_personnel_user_id: 'User ID:',
        time_tracking_personnel_store: 'Store:',
        time_tracking_personnel_username: 'Username:',
        time_tracking_personnel_status: 'Status:',
        time_tracking_personnel_national_id: 'National identity number / D number:',
        time_tracking_personnel_pin_saved: 'PIN saved:',
        time_tracking_personnel_last_updated: 'Last updated:',
        time_tracking_personnel_employee_number: 'Employee number',
        time_tracking_personnel_national_id_11_digits: 'National identity number / D number (11 digits)',
        time_tracking_personnel_pin_code: 'PIN code',
        time_tracking_personnel_new_pin_placeholder: 'New PIN code',
        time_tracking_personnel_empty_keeps_pin: 'Leave blank to keep the existing PIN.',
        time_tracking_personnel_export_title: 'Export personnel list',
        time_tracking_personnel_export_description: 'PDF printing and sending by email.',
        time_tracking_personnel_pdf_title: 'Personnel list PDF',
        time_tracking_personnel_download_pdf: 'Download PDF',
        time_tracking_personnel_send_email_title: 'Send personnel list by email',
        time_tracking_personnel_email_placeholder: 'email@company.com',
        time_tracking_personnel_send_email: 'Send email',
        time_tracking_personnel_employee_number_short: 'Employee no.:',
        time_tracking_personnel_birth_date: 'Date of birth:',
        time_tracking_personnel_load_error: 'Could not load the personnel list.',
        time_tracking_personnel_generating_pdf: 'Generating PDF...',
        time_tracking_personnel_generate_pdf_error: 'Could not generate PDF',
        time_tracking_personnel_pdf_ready: 'PDF is ready.',
        time_tracking_personnel_email_required: 'Enter an email address first.',
        time_tracking_personnel_sending_email: 'Sending email...',
        time_tracking_personnel_send_email_error: 'Could not send email',
        time_tracking_personnel_email_sent: 'The PDF was sent by email.',
        time_tracking_personnel_national_id_invalid: 'National identity number / D number must contain 11 digits.',
        time_tracking_personnel_save_error: 'Could not save personnel information.',
        time_tracking_settings_no_users: 'No users found.',
        time_tracking_settings_load_personnel_error: 'Could not load personnel-list settings.',
        time_tracking_settings_no_templates: 'No templates found.',
        time_tracking_settings_load_templates_error: 'Could not load shift templates.',
        time_tracking_settings_save_allowances_error: 'Could not save allowance hours.',
        time_tracking_settings_save_personnel_error: 'Could not save the personnel-list setting.',
        time_tracking_settings_name_required: 'Name is required.',
        time_tracking_settings_times_must_differ: 'From and to cannot be the same time.',
        time_tracking_settings_template_saved: 'Shift template saved.',
        time_tracking_settings_save_template_error: 'Could not save template.',
        time_tracking_settings_template_deactivated: 'Shift template deactivated.',
        time_tracking_settings_deactivate_template_error: 'Could not deactivate template.',
        time_tracking_settings_save_default_view_error: 'Could not save the default view.',
        statistics_account: 'Account',
        statistics_balance: 'Balance',
        statistics_basis: 'Basis',
        statistics_breakage: 'Waste',
        statistics_breakage_quantity: 'Waste quantity',
        statistics_cash_drawer_openings: 'Cash drawer openings',
        statistics_change: 'Change',
        statistics_change_percent: 'Change %',
        statistics_chart: 'Chart',
        statistics_clear: 'Clear',
        statistics_combined_daily_report: 'Combined daily settlement',
        statistics_combined_daily_reports: 'Combined daily settlements',
        statistics_comparison_table: 'Comparison table',
        statistics_coupon_report_load_error: 'Could not load the coupon report.',
        statistics_coupon_template: 'Coupon template',
        statistics_credit: 'Credit',
        statistics_customer: 'Customer',
        statistics_customer_card: 'Customer card',
        statistics_customer_number_short: 'Customer no.',
        statistics_customers: 'Customers',
        statistics_daily_settlement: 'Daily settlement',
        statistics_date: 'Date',
        statistics_date_time: 'Date/time',
        statistics_day: 'Day',
        statistics_debit: 'Debit',
        statistics_difference: 'Difference',
        statistics_discount_given: 'Discount given',
        statistics_discount_given_per_customer: 'Discount given per customer',
        statistics_discount_given_to_customers: 'Discount given to customers',
        statistics_discount_inc_vat: 'Discount incl. VAT',
        statistics_discount_lowercase: 'discount',
        statistics_discount_percent: 'Discount %',
        statistics_discount_sum_inc_vat: 'Discount total incl. VAT',
        statistics_discounted_sales_fetch_error: 'Could not fetch discounted sales for the product.',
        statistics_download: 'Download',
        statistics_download_limit_exceeded: 'No more than {limit} reports can be downloaded. Narrow the selection.',
        statistics_download_report: 'Download report',
        statistics_email_field_not_found: 'Could not find the email field.',
        statistics_employee: 'Employee',
        statistics_end_time: 'End time',
        statistics_enter_email: 'Please enter an email address.',
        statistics_enter_valid_email: 'Please enter a valid email address.',
        statistics_excel_generation_error: 'An error occurred while generating the Excel file.',
        statistics_fixed_max_amount: 'Fixed amount/maximum amount',
        statistics_fixed_max_amount_lowercase: 'fixed amount/maximum amount',
        statistics_hour: 'Hour',
        statistics_hourly_sales: 'Hourly sales',
        statistics_in_basis: 'In basis',
        statistics_in_basis_lowercase: 'in basis',
        statistics_invoice_basis: 'Invoice basis',
        statistics_invoice_basis_per_customer: 'Invoice basis per customer',
        statistics_invoice_short: 'inv.',
        statistics_issued: 'Issued',
        statistics_issued_coupons: 'Issued coupons',
        statistics_item: 'Item',
        statistics_item_lines: 'Item lines',
        statistics_items_sold: 'Items sold',
        statistics_last_sale: 'Last sale',
        statistics_loading_discounted_sales: 'Loading discounted sales...',
        statistics_lost_revenue_percent: 'Lost revenue (%)',
        statistics_miscellaneous: 'Miscellaneous',
        statistics_name: 'Name',
        statistics_no_daily_sales: 'No daily sales found.',
        statistics_no_data_in_period: 'No data in the period.',
        statistics_no_data_selected_filters: 'No data found for the selected filters.',
        statistics_no_data_selected_period: 'No data found for the selected period.',
        statistics_no_data_selected_period_filters: 'No data found for the selected period and filters.',
        statistics_no_discounted_products_selected_filters: 'No discounted products found for the selected filters.',
        statistics_no_discounted_sales_product: 'No discounted sales found for the product.',
        statistics_no_hourly_numbers: 'No hourly figures found.',
        statistics_no_invoice_basis_customers_selected_period: 'No invoice basis for customers in the selected period.',
        statistics_no_issued_coupons_selected_period: 'No issued coupons in the selected period.',
        statistics_no_miscellaneous_data: 'No miscellaneous data found.',
        statistics_no_orders_match_search: 'No orders match the search.',
        statistics_no_orders_selected_period_filters: 'No orders found for the selected period and filters.',
        statistics_no_payment_methods: 'No payment methods found.',
        statistics_no_product_groups: 'No product groups found.',
        statistics_no_products_match_search: 'No products match the search.',
        statistics_no_results: 'No results',
        statistics_no_user_sales: 'No user sales found.',
        statistics_no_vat_rates: 'No VAT rates found.',
        statistics_not_used: 'Not used',
        statistics_number_short: 'no.',
        statistics_order_id_sync_code_not_found: 'Could not find the order ID or sync code.',
        statistics_order_information_not_found: 'Could not find the order information.',
        statistics_orders_fetch_error: 'An error occurred while fetching order data.',
        statistics_orders_search_placeholder: 'Search receipt number, customer, table, payment method or products...',
        statistics_payment_method: 'Payment method',
        statistics_payment_method_short: 'Payment method',
        statistics_payment_methods: 'Payment methods',
        statistics_pcs: 'pcs',
        statistics_pdf_generation_error: 'An error occurred while generating the PDF.',
        statistics_percent_of_sales_ex_vat: '% of sales excl. VAT',
        statistics_period: 'Period',
        statistics_period_a: 'Period A',
        statistics_period_b: 'Period B',
        statistics_price_inc_vat: 'Price incl. VAT',
        statistics_product: 'Product',
        statistics_product_discounts_fetch_error: 'Could not fetch product discounts.',
        statistics_product_group: 'Product group',
        statistics_product_group_sales: 'Product group sales',
        statistics_product_group_share: 'Product group share',
        statistics_product_number: 'Product number',
        statistics_products: 'products',
        statistics_quantity: 'Quantity',
        statistics_quantity_items: 'Number of items',
        statistics_quantity_items_sold: 'Number of items sold',
        statistics_quantity_sold: 'Quantity sold',
        statistics_receipt: 'Receipt',
        statistics_receipt_container_not_found: 'Could not find the receipt container.',
        statistics_receipt_number: 'Receipt number',
        statistics_receipt_send_error: 'Could not send the receipt. Please try again.',
        statistics_receipt_sent: 'Receipt sent!',
        statistics_reconciliation: 'Reconciliation',
        statistics_reconciliations: 'Reconciliations',
        statistics_register: 'Register',
        statistics_register_and_date: 'Register and date',
        statistics_registered_users: 'Registered users',
        statistics_reports_in_selection: 'Reports in the selection',
        statistics_return_value: 'Return value',
        statistics_sales: 'Sales',
        statistics_sales_inc_vat: 'Sales incl. VAT',
        statistics_sales_per_hour: 'Sales per hour',
        statistics_sales_per_user_inc_vat: 'Sales per user (incl. VAT)',
        statistics_sales_share_percent: 'Share of sales (%)',
        statistics_selected_product_not_found: 'Could not find the selected product.',
        statistics_share_percent: 'Share (%)',
        statistics_sending: 'Sending...',
        statistics_sorting: 'Sorting',
        statistics_start_time: 'Start time',
        statistics_status: 'Status',
        statistics_store: 'Store',
        statistics_sum: 'Sum',
        statistics_sum_all_items: 'Sum of all items',
        statistics_sum_ex_vat: 'Sum excl. VAT',
        statistics_sum_inc_vat: 'Sum incl. VAT',
        statistics_sum_period_a: 'Sum (Period A)',
        statistics_sum_period_b: 'Sum (Period B)',
        statistics_table: 'Table',
        statistics_time: 'Time',
        statistics_time_point: 'Time',
        statistics_to_be_invoiced: 'To be invoiced',
        statistics_top_10_products: 'Top 10 products',
        statistics_top_10_sellers: 'Top 10 sellers',
        statistics_top_5_stores: 'Top 5 stores',
        statistics_total: 'Total',
        statistics_total_all_product_groups: 'Total for all product groups',
        statistics_total_sales_inc_vat: 'Total sales incl. VAT',
        statistics_total_sales_per_weekday: 'Total sales per weekday',
        statistics_total_sum: 'Total sum',
        statistics_transactions_count: 'Number of transactions',
        statistics_type: 'Type',
        statistics_type_at_least_2_characters: 'Type at least 2 characters to search…',
        statistics_type_at_least_3_characters: 'Type at least 3 characters to search…',
        statistics_unknown: 'Unknown',
        statistics_usage: 'Usage',
        statistics_used: 'Used',
        statistics_used_lowercase: 'used',
        statistics_user: 'User',
        statistics_user_details: 'User details',
        statistics_validity: 'Validity',
        statistics_value: 'Value',
        statistics_vat_amount: 'VAT amount',
        statistics_vat_code: 'VAT code',
        statistics_vat_percent: 'VAT percent',
        statistics_vat_percent_short: 'VAT%',
        statistics_vat_rates: 'VAT rates',
        statistics_z_report: 'Z report',
        statistics_z_reports: 'Z reports'
    },
    no: {
        cancel: 'Avbryt',
        close: 'Lukk',
        error: 'Feil',
        info: 'Info',
        loading: 'Laster...',
        no: 'Nei',
        save: 'Lagre',
        update: 'Oppdater',
        yes: 'Ja',
        time_tracking_admin_new_clocking: 'Lagre ny stempling',
        time_tracking_admin_edit_clocking: 'Endre stempling',
        time_tracking_admin_clocking_saved: 'Stempling lagret!',
        time_tracking_admin_error_occurred: 'Det oppstod en feil!',
        time_tracking_admin_fetch_shifts_error: 'Kunne ikke hente stemplinger, vennligst prøv igjen',
        time_tracking_admin_fetching_data: 'Henter data...',
        time_tracking_calendar_save_shift: 'Lagre vakt',
        time_tracking_calendar_saving: 'Lagrer...',
        time_tracking_calendar_fetch_employees_error: 'Kunne ikke hente ansatte for valgt butikk.',
        time_tracking_calendar_unknown_user: 'Ukjent bruker',
        time_tracking_calendar_select_shift_for_details: 'Velg en vakt i kalenderen for detaljer.',
        time_tracking_calendar_details_coming_later: 'Detaljvisning kommer senere.',
        time_tracking_calendar_shift_details: 'Vaktdetaljer',
        time_tracking_calendar_employee: 'Ansatt',
        time_tracking_calendar_select_employee: 'Velg ansatt',
        time_tracking_calendar_store: 'Butikk',
        time_tracking_calendar_from_time: 'Fra (tid)',
        time_tracking_calendar_to_time: 'Til (tid)',
        time_tracking_calendar_shift_template: 'Vaktmal',
        time_tracking_calendar_no_template: 'Ingen mal',
        time_tracking_calendar_comment: 'Kommentar',
        time_tracking_calendar_optional_comment: 'Valgfri kommentar',
        time_tracking_calendar_required_fields: 'Fyll inn alle påkrevde felt.',
        time_tracking_calendar_times_must_differ: 'Starttid og sluttid kan ikke være samme tidspunkt.',
        time_tracking_calendar_edit_shift_not_found: 'Fant ikke eksisterende vakt for redigering.',
        time_tracking_calendar_updating_shift: 'Oppdaterer vakt...',
        time_tracking_calendar_update_shift_error: 'Kunne ikke oppdatere vakten.',
        time_tracking_calendar_overlapping: 'overlappende',
        time_tracking_calendar_adjacent: 'tilstøtende',
        time_tracking_calendar_conflict_title: 'Varsel om tilstøtende / overlappende vakter',
        time_tracking_calendar_conflict_description: 'Den ansatte har allerede vakt som er tilstøtende eller overlapper denne perioden:',
        time_tracking_calendar_save_anyway: 'Lagre likevel',
        time_tracking_calendar_unknown_save_error: 'Ukjent feil ved lagring av vakt.',
        time_tracking_calendar_save_error: 'Kunne ikke lagre vakt.',
        time_tracking_calendar_delete_target_not_found: 'Fant ikke vakten som skulle slettes.',
        time_tracking_calendar_unknown_delete_error: 'Ukjent feil ved sletting av vakt.',
        time_tracking_calendar_delete_error: 'Kunne ikke slette vakt.',
        time_tracking_calendar_delete_shift: 'Slett vakt',
        time_tracking_calendar_selected_days: 'Valgte dager:',
        time_tracking_calendar_no_shifts: 'Ingen vakter',
        time_tracking_calendar_hours_short: 't',
        time_tracking_calendar_drop_to_move: 'Slipp for å flytte vakt',
        time_tracking_calendar_drop_to_create: 'Slipp for å opprette vakt',
        time_tracking_calendar_shift: 'Vakt',
        time_tracking_calendar_week: 'Uke',
        time_tracking_calendar_day_sun_short: 'Søn',
        time_tracking_calendar_day_mon_short: 'Man',
        time_tracking_calendar_day_tue_short: 'Tir',
        time_tracking_calendar_day_wed_short: 'Ons',
        time_tracking_calendar_day_thu_short: 'Tor',
        time_tracking_calendar_day_fri_short: 'Fre',
        time_tracking_calendar_day_sat_short: 'Lør',
        time_tracking_calendar_month_january: 'Januar',
        time_tracking_calendar_month_february: 'Februar',
        time_tracking_calendar_month_march: 'Mars',
        time_tracking_calendar_month_april: 'April',
        time_tracking_calendar_month_may: 'Mai',
        time_tracking_calendar_month_june: 'Juni',
        time_tracking_calendar_month_july: 'Juli',
        time_tracking_calendar_month_august: 'August',
        time_tracking_calendar_month_september: 'September',
        time_tracking_calendar_month_october: 'Oktober',
        time_tracking_calendar_month_november: 'November',
        time_tracking_calendar_month_december: 'Desember',
        time_tracking_calendar_no_days_selected: 'Ingen dager er valgt.',
        time_tracking_calendar_save_multiple_error: 'Kunne ikke lagre en eller flere vakter.',
        time_tracking_calendar_template_fallback: 'Mal',
        time_tracking_calendar_move_target_not_found: 'Fant ikke vakten som skulle flyttes.',
        time_tracking_calendar_invalid_move_cell: 'Ugyldig kalendercelle for flytting.',
        time_tracking_calendar_partial_move_error: 'Vakten ble opprettet i ny celle, men kunne ikke slettes fra gammel celle.',
        time_tracking_calendar_move_error: 'Kunne ikke flytte vakten.',
        time_tracking_calendar_select_day_and_employee: 'Velg en dag og ansatt for å opprette vakt.',
        time_tracking_calendar_shift_not_found: 'Fant ikke vakten.',
        time_tracking_calendar_delete_confirmation: 'Er du sikker på at du vil slette denne vakten? Dette kan ikke angres.',
        time_tracking_dashboard_user: 'Bruker',
        time_tracking_dashboard_no_data: 'Ingen data i valgt periode.',
        time_tracking_dashboard_ongoing: 'Pågående',
        time_tracking_dashboard_deviation: 'Avvik',
        time_tracking_dashboard_planned_hours: 'Planlagte timer',
        time_tracking_dashboard_actual_hours: 'Faktiske timer',
        time_tracking_dashboard_no_ongoing_shifts: 'Ingen pågående vakter.',
        time_tracking_dashboard_start: 'Start:',
        time_tracking_dashboard_changed_by: 'Endret av:',
        time_tracking_dashboard_click_for_actions: 'Klikk for handlinger',
        time_tracking_dashboard_in_progress: 'Pågår',
        time_tracking_dashboard_without_planned_shift: 'Uten planlagt vakt',
        time_tracking_dashboard_minor_deviation: 'Mindre avvik',
        time_tracking_dashboard_minutes_late_in: 'min sent inn',
        time_tracking_dashboard_minutes_early_in: 'min tidlig inn',
        time_tracking_dashboard_minutes_overtime: 'min overtid',
        time_tracking_dashboard_minutes_early_out: 'min tidlig ut',
        time_tracking_dashboard_no_history: 'Ingen historikk i valgt periode.',
        time_tracking_dashboard_comparison_description: 'Sammenligning av planlagt og faktisk arbeidstid',
        time_tracking_dashboard_planned: 'Planlagt',
        time_tracking_dashboard_actual: 'Faktisk',
        time_tracking_dashboard_comment: 'Kommentar:',
        time_tracking_dashboard_clocking_not_found: 'Fant ikke stempling.',
        time_tracking_dashboard_ongoing_shift: 'Pågående vakt',
        time_tracking_dashboard_edit_shift: 'Endre vakt',
        time_tracking_dashboard_in: 'Inn',
        time_tracking_dashboard_out: 'Ut',
        time_tracking_dashboard_clock_out: 'Stemple ut',
        time_tracking_dashboard_save_changes: 'Lagre endringer',
        time_tracking_dashboard_processing: 'Behandler...',
        time_tracking_dashboard_invalid_time_range: 'Ugyldig tidsintervall.',
        time_tracking_dashboard_clocking_out: 'Stempler ut...',
        time_tracking_dashboard_clock_out_in_progress: 'Utfører utstempling...',
        time_tracking_dashboard_clock_out_error: 'Kunne ikke stemple ut.',
        time_tracking_dashboard_saving: 'Lagrer...',
        time_tracking_dashboard_saving_changes: 'Lagrer endringer...',
        time_tracking_dashboard_update_clocking_error: 'Kunne ikke oppdatere stempling.',
        time_tracking_dashboard_export_payroll: 'Eksporter lønnsliste',
        time_tracking_dashboard_export_period_description: 'Velg periode for Excel-eksport.',
        time_tracking_dashboard_period: 'Periode',
        time_tracking_dashboard_download_excel: 'Last ned Excel',
        time_tracking_dashboard_invalid_date_range: 'Velg gyldig datointervall.',
        time_tracking_dashboard_generating_excel: 'Genererer Excel...',
        time_tracking_dashboard_generate_excel_error: 'Kunne ikke generere Excel',
        time_tracking_dashboard_excel_ready: 'Excel er klar.',
        time_tracking_dashboard_no_shifts_in_view: 'Ingen vakter i gjeldende kalendervisning.',
        time_tracking_dashboard_generate_pdf_error: 'Kunne ikke generere PDF',
        time_tracking_personnel_empty_keeps_number: 'Tomt felt beholder eksisterende nummer.',
        time_tracking_personnel_national_id_locked: 'Personnummer / D-nummer er låst etter første lagring.',
        time_tracking_personnel_update_information: 'Oppdater personellinformasjon',
        time_tracking_personnel_user_id: 'Bruker-ID:',
        time_tracking_personnel_store: 'Butikk:',
        time_tracking_personnel_username: 'Brukernavn:',
        time_tracking_personnel_status: 'Status:',
        time_tracking_personnel_national_id: 'Personnummer / D-nummer:',
        time_tracking_personnel_pin_saved: 'PIN lagret:',
        time_tracking_personnel_last_updated: 'Sist oppdatert:',
        time_tracking_personnel_employee_number: 'Ansattnummer',
        time_tracking_personnel_national_id_11_digits: 'Personnummer / D-nummer (11 siffer)',
        time_tracking_personnel_pin_code: 'PIN-kode',
        time_tracking_personnel_new_pin_placeholder: 'Ny PIN-kode',
        time_tracking_personnel_empty_keeps_pin: 'Tomt felt beholder eksisterende PIN.',
        time_tracking_personnel_export_title: 'Eksporter personalliste',
        time_tracking_personnel_export_description: 'PDF-utskrift og sending på e-post.',
        time_tracking_personnel_pdf_title: 'Personalliste PDF',
        time_tracking_personnel_download_pdf: 'Last ned PDF',
        time_tracking_personnel_send_email_title: 'Send personalliste på e-post',
        time_tracking_personnel_email_placeholder: 'epost@firma.no',
        time_tracking_personnel_send_email: 'Send e-post',
        time_tracking_personnel_employee_number_short: 'Ansattnr:',
        time_tracking_personnel_birth_date: 'Fødselsdato:',
        time_tracking_personnel_load_error: 'Kunne ikke laste personalliste.',
        time_tracking_personnel_generating_pdf: 'Genererer PDF...',
        time_tracking_personnel_generate_pdf_error: 'Kunne ikke generere PDF',
        time_tracking_personnel_pdf_ready: 'PDF er klar.',
        time_tracking_personnel_email_required: 'Legg inn e-postadresse først.',
        time_tracking_personnel_sending_email: 'Sender e-post...',
        time_tracking_personnel_send_email_error: 'Kunne ikke sende e-post',
        time_tracking_personnel_email_sent: 'PDF ble sendt på e-post.',
        time_tracking_personnel_national_id_invalid: 'Personnummer / D-nummer må være 11 siffer.',
        time_tracking_personnel_save_error: 'Kunne ikke lagre personellinformasjon.',
        time_tracking_settings_no_users: 'Ingen brukere funnet.',
        time_tracking_settings_load_personnel_error: 'Kunne ikke laste personallistevalg.',
        time_tracking_settings_no_templates: 'Ingen maler funnet.',
        time_tracking_settings_load_templates_error: 'Kunne ikke laste vaktmaler.',
        time_tracking_settings_save_allowances_error: 'Kunne ikke lagre tilleggstider.',
        time_tracking_settings_save_personnel_error: 'Kunne ikke lagre personallistevalg.',
        time_tracking_settings_name_required: 'Navn er påkrevd.',
        time_tracking_settings_times_must_differ: 'Fra og til kan ikke være samme tidspunkt.',
        time_tracking_settings_template_saved: 'Vaktmal lagret.',
        time_tracking_settings_save_template_error: 'Kunne ikke lagre mal.',
        time_tracking_settings_template_deactivated: 'Vaktmal deaktivert.',
        time_tracking_settings_deactivate_template_error: 'Kunne ikke deaktivere mal.',
        time_tracking_settings_save_default_view_error: 'Kunne ikke lagre standardvisning.',
        statistics_account: 'Konto',
        statistics_balance: 'Balanse',
        statistics_basis: 'Grunnlag',
        statistics_breakage: 'Svinn',
        statistics_breakage_quantity: 'Antall svinn',
        statistics_cash_drawer_openings: 'Kasseskuffåpninger',
        statistics_change: 'Endring',
        statistics_change_percent: 'Endring %',
        statistics_chart: 'Diagram',
        statistics_clear: 'Tøm',
        statistics_combined_daily_report: 'Fellesoppgjør',
        statistics_combined_daily_reports: 'Fellesoppgjør',
        statistics_comparison_table: 'Sammenligningstabell',
        statistics_coupon_report_load_error: 'Kunne ikke laste kupongrapporten.',
        statistics_coupon_template: 'Kupongmal',
        statistics_credit: 'Kredit',
        statistics_customer: 'Kunde',
        statistics_customer_card: 'Kundekort',
        statistics_customer_number_short: 'Kundenr.',
        statistics_customers: 'Kunder',
        statistics_daily_settlement: 'Dagsoppgjør',
        statistics_date: 'Dato',
        statistics_date_time: 'Dato/tid',
        statistics_day: 'Dag',
        statistics_debit: 'Debet',
        statistics_difference: 'Differanse',
        statistics_discount_given: 'Rabatt gitt',
        statistics_discount_given_per_customer: 'Rabatt gitt pr. kunde',
        statistics_discount_given_to_customers: 'Rabatt gitt til kunder',
        statistics_discount_inc_vat: 'Rabatt inkl. MVA',
        statistics_discount_lowercase: 'rabatt',
        statistics_discount_percent: 'Rabatt %',
        statistics_discount_sum_inc_vat: 'Rabatt sum inkl. MVA',
        statistics_discounted_sales_fetch_error: 'Kunne ikke hente rabatterte salg for produktet.',
        statistics_download: 'Last ned',
        statistics_download_limit_exceeded: 'Kan ikke laste ned mer enn {limit} rapporter. Snevre inn utvalget.',
        statistics_download_report: 'Last ned rapport',
        statistics_email_field_not_found: 'Kunne ikke finne e-postfelt.',
        statistics_employee: 'Ansatt',
        statistics_end_time: 'Sluttid',
        statistics_enter_email: 'Vennligst skriv inn en e-postadresse.',
        statistics_enter_valid_email: 'Vennligst skriv inn en gyldig e-postadresse.',
        statistics_excel_generation_error: 'Det oppstod en feil under generering av Excel-filen.',
        statistics_fixed_max_amount: 'Fastbeløp/maksbeløp',
        statistics_fixed_max_amount_lowercase: 'fastbeløp/maksbeløp',
        statistics_hour: 'Time',
        statistics_hourly_sales: 'Salgstall pr. time',
        statistics_in_basis: 'I grunnlag',
        statistics_in_basis_lowercase: 'i grunnlag',
        statistics_invoice_basis: 'Fakturagrunnlag',
        statistics_invoice_basis_per_customer: 'Fakturagrunnlag per kunde',
        statistics_invoice_short: 'fakt.',
        statistics_issued: 'Utstedt',
        statistics_issued_coupons: 'Utstedte kuponger',
        statistics_item: 'Vare',
        statistics_item_lines: 'Varelinjer',
        statistics_items_sold: 'Solgte varer',
        statistics_last_sale: 'Siste salg',
        statistics_loading_discounted_sales: 'Laster rabatterte salg...',
        statistics_lost_revenue_percent: 'Tapt omsetning (%)',
        statistics_miscellaneous: 'Diverse',
        statistics_name: 'Navn',
        statistics_no_daily_sales: 'Ingen daglig salg funnet.',
        statistics_no_data_in_period: 'Ingen data i perioden.',
        statistics_no_data_selected_filters: 'Ingen data funnet for valgte filtre.',
        statistics_no_data_selected_period: 'Ingen data funnet for valgt periode.',
        statistics_no_data_selected_period_filters: 'Ingen data funnet for den valgte tidsperioden og filtrene.',
        statistics_no_discounted_products_selected_filters: 'Ingen produkter med rabatt funnet for valgte filtre.',
        statistics_no_discounted_sales_product: 'Ingen rabatterte salg funnet for produktet.',
        statistics_no_hourly_numbers: 'Ingen timetall funnet.',
        statistics_no_invoice_basis_customers_selected_period: 'Ingen fakturagrunnlag for kunder i valgt periode.',
        statistics_no_issued_coupons_selected_period: 'Ingen utstedte kuponger i valgt periode.',
        statistics_no_miscellaneous_data: 'Ingen diverse data funnet.',
        statistics_no_orders_match_search: 'Ingen ordre matcher søket.',
        statistics_no_orders_selected_period_filters: 'Ingen ordre funnet for valgt periode og filtre.',
        statistics_no_payment_methods: 'Ingen betalingsmidler funnet.',
        statistics_no_product_groups: 'Ingen varegrupper funnet.',
        statistics_no_products_match_search: 'Ingen produkter matcher søket.',
        statistics_no_results: 'Ingen treff',
        statistics_no_user_sales: 'Ingen brukersalg funnet.',
        statistics_no_vat_rates: 'Ingen MVA-satser funnet.',
        statistics_not_used: 'Ikke brukt',
        statistics_number_short: 'nr.',
        statistics_order_id_sync_code_not_found: 'Kunne ikke finne ordre-ID eller sync-kode.',
        statistics_order_information_not_found: 'Kunne ikke finne ordre-informasjon.',
        statistics_orders_fetch_error: 'Feil oppstod under henting av ordredata.',
        statistics_orders_search_placeholder: 'Søk i kvitteringsnr., kunde, bord, betalingsmiddel eller produkter...',
        statistics_payment_method: 'Betalingsmiddel',
        statistics_payment_method_short: 'Bet. middel',
        statistics_payment_methods: 'Betalingsmidler',
        statistics_pcs: 'Stk',
        statistics_pdf_generation_error: 'Det oppstod en feil under generering av PDF-en.',
        statistics_percent_of_sales_ex_vat: '% av omsetning eks. MVA',
        statistics_period: 'Periode',
        statistics_period_a: 'Periode A',
        statistics_period_b: 'Periode B',
        statistics_price_inc_vat: 'Pris inkl. MVA',
        statistics_product: 'Produkt',
        statistics_product_discounts_fetch_error: 'Kunne ikke hente produktrabatter.',
        statistics_product_group: 'Varegruppe',
        statistics_product_group_sales: 'Varegruppesalg',
        statistics_product_group_share: 'Varegruppeandel',
        statistics_product_number: 'Varenummer',
        statistics_products: 'produkter',
        statistics_quantity: 'Antall',
        statistics_quantity_items: 'Antall varer',
        statistics_quantity_items_sold: 'Antall solgte varer',
        statistics_quantity_sold: 'Antall solgt',
        statistics_receipt: 'Kvittering',
        statistics_receipt_container_not_found: 'Kunne ikke finne kvitteringscontainer.',
        statistics_receipt_number: 'Kvitteringsnummer',
        statistics_receipt_send_error: 'Kunne ikke sende kvittering. Vennligst prøv igjen.',
        statistics_receipt_sent: 'Kvittering sendt!',
        statistics_reconciliation: 'Avstemming',
        statistics_reconciliations: 'Avstemminger',
        statistics_register: 'Kasse',
        statistics_register_and_date: 'Kasse og dato',
        statistics_registered_users: 'Registrerte brukere',
        statistics_reports_in_selection: 'Rapporter i utvalget',
        statistics_return_value: 'Returverdi',
        statistics_sales: 'Salg',
        statistics_sales_inc_vat: 'Salg inkl. MVA',
        statistics_sales_per_hour: 'Salg per time',
        statistics_sales_per_user_inc_vat: 'Salg pr. bruker (inkl. MVA)',
        statistics_sales_share_percent: 'Andel av salg (%)',
        statistics_selected_product_not_found: 'Fant ikke valgt produkt.',
        statistics_share_percent: 'Andel (%)',
        statistics_sending: 'Sender...',
        statistics_sorting: 'Sortering',
        statistics_start_time: 'Starttid',
        statistics_status: 'Status',
        statistics_store: 'Butikk',
        statistics_sum: 'Sum',
        statistics_sum_all_items: 'Sum alle varer',
        statistics_sum_ex_vat: 'Sum eks. MVA',
        statistics_sum_inc_vat: 'Sum inkl. MVA',
        statistics_sum_period_a: 'Sum (Periode A)',
        statistics_sum_period_b: 'Sum (Periode B)',
        statistics_table: 'Bord',
        statistics_time: 'Tid',
        statistics_time_point: 'Tidspunkt',
        statistics_to_be_invoiced: 'Faktureres',
        statistics_top_10_products: 'Topp 10 produkter',
        statistics_top_10_sellers: 'Topp 10 selgere',
        statistics_top_5_stores: 'Topp 5 butikker',
        statistics_total: 'Totalt',
        statistics_total_all_product_groups: 'Totalt for alle produktgrupper',
        statistics_total_sales_inc_vat: 'Totalt salg inkl. MVA',
        statistics_total_sales_per_weekday: 'Totalt salg pr. ukedag',
        statistics_total_sum: 'Totalsum',
        statistics_transactions_count: 'Antall handler',
        statistics_type: 'Type',
        statistics_type_at_least_2_characters: 'Skriv minst 2 tegn for å søke…',
        statistics_type_at_least_3_characters: 'Skriv minst 3 tegn for å søke…',
        statistics_unknown: 'Ukjent',
        statistics_usage: 'Bruk',
        statistics_used: 'Brukt',
        statistics_used_lowercase: 'brukt',
        statistics_user: 'Bruker',
        statistics_user_details: 'Bruker-detaljer',
        statistics_validity: 'Gyldighet',
        statistics_value: 'Verdi',
        statistics_vat_amount: 'MVA-beløp',
        statistics_vat_code: 'MVA-kode',
        statistics_vat_percent: 'MVA-prosent',
        statistics_vat_percent_short: 'MVA%',
        statistics_vat_rates: 'MVA-satser',
        statistics_z_report: 'Z-rapport',
        statistics_z_reports: 'Z-rapporter'
    }
};

window.translation = translation;
